import { Component, Input } from '@angular/core';
import { StaticFileHash } from '@scalefast/ecommerce-core';
import { ContentfulFeedbackContent } from '../../../../core/interfaces/Contentful/Feedback/ContentfulFeedbackContent';

@Component({
  selector: 'app-contentful-feedback',
  templateUrl: './contentful-feedback.component.html',
  styleUrls: ['./contentful-feedback.component.scss'],
  standalone: true,
  imports: [StaticFileHash],
})
export class AppContentfulFeedbackComponent {
  @Input() faqFeedback: ContentfulFeedbackContent | undefined;
  faqFeedbackImageUrl: string | undefined;
  faqFeedbackReceived = false;

  onFaqFeedbackReceived() {
    this.faqFeedbackReceived = true;
  }
}
